/* eslint-disable */

import {config} from '@shared/_services/config';
import {authHeader, handleResponse} from '@shared/_helpers';

import UserResourceApi from '@shared/_api/userResources';
import {FETCH_RESOURCES_SUCCESS} from "./mutationTypes";

const state = {
    resourcesLoaded: true,
    resources: [],
};

const getters = {
    resourceNames: state => {
        if (state.resources && state.resources.length > 0) {
            return state.resources.map(el => el.name)
        }
        return []
    },
};

const actions = {
    fetchResources({commit}) {
        UserResourceApi.fetchAll()
            .then(resources => commit(FETCH_RESOURCES_SUCCESS, resources))
            .catch(error => console.log(error))
    },
};

const mutations = {
    [FETCH_RESOURCES_SUCCESS](state, resources) {
        state.resources = resources;
        state.resourcesLoaded = true
    }
};

export const resourcesManagement = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};